import { AnalyticsStore } from 'bernie-plugin-mobx';
import { trackAnalytics } from 'utility/analytics';
import { ClientMetadataStore } from 'stores';
import { UitkTextProps } from 'uitk-react-text';

export const setPageTitle = (clientMetadataStore: ClientMetadataStore, analytics: AnalyticsStore) => {
  const { clientMetadata } = clientMetadataStore ?? {};
  const pageName = clientMetadata?.pageName;
  const pageNameAnalytics = clientMetadata?.pageNameAnalytics;

  if (pageName && pageNameAnalytics) {
    document.title = pageName;
    trackAnalytics(pageNameAnalytics, analytics);
  }
};

export const textSizeMapper = (size: number): UitkTextProps['size'] => {
  switch (size) {
    case 100:
      return 100;
    default:
      return 200;
  }
};
